import { useCandidateHandlers } from "./candidate/candidateHandlers";
import { useCandidateErrorHandlers } from "./candidateErrorHandlers";
import { CandidateState } from "./candidateState";
import { FeatureActions } from "./combinedCandidatesFeatureActions";

export const useCombinedLeadsFeatureHandlers = (
    state: CandidateState,
    actions: FeatureActions
) => {
    useCandidateErrorHandlers(state, actions);
    useCandidateHandlers(state, actions);
};
